import { IkasBaseModel } from "../base";
import { IkasCheckoutOption } from "./option";
import { IkasCheckoutSettingsPrice } from "./price";

export type IkasCheckoutSettings = {
  giftPackagePriceList: IkasCheckoutSettingsPrice[] | null;
  identityNumberRequirement: IkasCheckoutRequirement;
  isAccountRequired: boolean;
  isGiftPackageEnabled: boolean | null;
  isQuickRegistrationEnabled: boolean | null;
  isShowPostalCode: boolean | null;
  isTermsAndConditionsDefaultChecked: boolean | null;
  options: IkasCheckoutOption[] | null;
  phoneRequirement: IkasCheckoutRequirement;
  postalCodeRequirement: IkasCheckoutRequirement | null;
  showCheckoutNote: boolean | null;
  showTermsAndConditionsCheckbox: boolean;
  storefrontId: string;
} & IkasBaseModel;

export enum IkasCheckoutRequirement {
  INVISIBLE = "INVISIBLE",
  MANDATORY = "MANDATORY",
  OPTIONAL = "OPTIONAL",
}
